<template>
  <v-container fill-height :style="{
      backgroundColor: colors.blue,
      margin: 0,
      minWidth: '100%',
      position: 'relative'
    }">
    <div 
      :style="{
        backgroundImage: 'url(/assets/bg.png)', 
        backgroundSize: 'cover', /* Use cover to make sure the image covers the entire container */
        backgroundPosition: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%', /* Set height to 100% to fill the container */
        opacity: 0.1
      }">
    </div>
    <!-- Welcome Screen Content -->
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="auto">
        <!-- Heading for Evaluation Grid -->
        <h2 class="text-center mb-4" :style="{color: colors.secondary}">GRILLE D'ÉVALUATION BAOBAB 2024</h2>

        <!-- Baobab Image -->
        <v-img
          src="/assets/baobabwhite.png"
          alt="Baobab Logo"
          min-width="100%"
          class="mx-auto mb-4"
        ></v-img>
        <div :style="{backgroundColor: colors.secondary, borderRadius: '20px'}">
        <!-- Developed by Text -->
        <h3 class="text-center mb-4">Développé par</h3>

        <!-- Logos -->
        <a href="https://thewebsquare.com" target="_blank">
          <v-img
            src="/assets/logo.png"
            alt="Developed By Logo"
            max-width="250"
            class="mx-auto mb-4"
            style="border-bottom: 1px solid #e5e5e5; width: 300px; padding: 10px; margin: 0 auto;"
          ></v-img>
        </a>

        <div style="width: 200px; margin: 0 auto; padding:5px;">
          <div style="display: flex; justify-content: space-between">
              <div>
                  <a href="https://pyramidpos.com" target="_blank">
                    <v-img
                      src="/assets/logopyramid.png"
                      alt="Developed By Logo"
                      max-width="50"
                      class="mx-auto mb-4"
                      style="width: 300px; margin: 0 auto;"
                    ></v-img>
                  </a>
              </div>
              <div>
                  <a href="https://rest-o-pos.com" target="_blank">
                    <v-img
                      src="/assets/rop.png"
                      alt="Developed By Logo"
                      max-width="50"
                      class="mx-auto mb-4"
                      style="width: 300px; margin: 0 auto;"
                    ></v-img>
                  </a>
              </div>
          </div>
        </div>
        <a href="https://nexta.mg" target="_blank">
        <v-img
          src="/assets/incube.png"
          alt="Incube Image"
          max-width="75"
          class="mx-auto mb-4"
        ></v-img>
        </a>
        </div>

        <!-- Continue Button -->
        <v-btn
          class="mx-auto mt-4"
          :color="colors.primary"
          @click="goToJurySelection"
        >
          Continuer
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import colors from "../styles/colors";
export default {
  name: 'WelcomeScreen',
  data() {
    return {
      colors,
    }
  },
  methods: {
    goToJurySelection() {
      // Navigate to the Jury Selection screen
      this.$router.push('/jury-selection');
    }
  }
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}

.text-center {
  text-align: center;
}
</style>
